import { useCallback } from "react";
import { toast } from "@/components/ui/notify";

// Cópia para a área de transferência com fallback gracioso (sem `console.*`):
// feature-detecta `navigator.clipboard` e trata a rejeição. Reusável (UUID, chave do CLP, …).
export function useCopyToClipboard() {
  return useCallback((text: string, successMsg = "Copiado.") => {
    const clip = navigator.clipboard;
    if (!clip?.writeText) {
      toast.error("Não foi possível copiar.", {
        description: "Área de transferência indisponível neste contexto.",
      });
      return;
    }
    void clip.writeText(text).then(
      () => toast.success(successMsg),
      () => toast.error("Não foi possível copiar.")
    );
  }, []);
}
